var map = {
	"./Pages/About/About.module": [
		"./src/app/Pages/About/About.module.ts",
		"Pages-About-About-module"
	],
	"./Pages/Blogs/Blogs.module": [
		"./src/app/Pages/Blogs/Blogs.module.ts",
		"Pages-Blogs-Blogs-module"
	],
	"./Pages/Checkout/Checkout.module": [
		"./src/app/Pages/Checkout/Checkout.module.ts",
		"Pages-Checkout-Checkout-module"
	],
	"./Pages/Products/Products.module": [
		"./src/app/Pages/Products/Products.module.ts",
		"default~Pages-Products-Products-module~Pages-Session-Session-module",
		"Pages-Products-Products-module"
	],
	"./Pages/Session/Session.module": [
		"./src/app/Pages/Session/Session.module.ts",
		"default~Pages-Products-Products-module~Pages-Session-Session-module",
		"Pages-Session-Session-module"
	],
	"./Pages/UserAccount/UserAccount.module": [
		"./src/app/Pages/UserAccount/UserAccount.module.ts",
		"Pages-UserAccount-UserAccount-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;